// FIX-02 — real 404 page. Unknown routes must NOT redirect to / or /login.
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Activity } from "lucide-react";

export default function NotFoundPage() {
  useEffect(() => { document.title = "404 — Page not found · MarkovLab"; }, []);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ background: "var(--hoip-bg)", color: "var(--hoip-text-primary)" }}
      data-testid="not-found-page">
      <div className="flex items-center gap-2 mb-6">
        <Activity className="w-6 h-6 text-emerald-500" />
        <span className="text-xl font-bold tracking-tight" style={{ fontFamily: "Chivo, sans-serif" }}>MarkovLab</span>
      </div>
      <div className="text-5xl font-extrabold mb-2" style={{ fontFamily: "Chivo, sans-serif" }}>404</div>
      <p className="text-sm mb-6" style={{ color: "var(--hoip-text-secondary)" }} data-testid="not-found-message">
        Page not found. The page you're looking for doesn't exist or was moved.
      </p>
      <Link to="/" data-testid="not-found-home-link"
        className="px-4 py-2 text-xs font-bold rounded-sm mb-8"
        style={{ background: "var(--hoip-profit)", color: "#000" }}>
        Back to home
      </Link>
      <div className="flex items-center gap-4 text-[11px]" style={{ color: "var(--hoip-text-tertiary)" }}>
        <Link to="/legal/terms" className="underline" data-testid="not-found-terms">Terms</Link>
        <Link to="/legal/privacy" className="underline" data-testid="not-found-privacy">Privacy</Link>
        <Link to="/legal/risk" className="underline" data-testid="not-found-risk">Risk Disclosure</Link>
        <Link to="/legal/refund" className="underline" data-testid="not-found-refund">Refund Policy</Link>
        <Link to="/contact" className="underline" data-testid="not-found-contact">Contact</Link>
      </div>
    </div>
  );
}
